import React from "react";
import CompactDailyForm from "./CompactDailyForm";

export default function Dashboard() {
  return (
    <div className="min-h-screen bg-slate-50">
      <CompactDailyForm />
    </div>
  );
}
